import { useEffect, useState } from "react";
import { api } from "../../lib/adventureApi";
import VideoReviewCard from "./VideoReviewCard";

export default function TourVideoReviews({ tourSlug }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/video-reviews", { params: { tour_slug: tourSlug, limit: 8 } }).then((r) => {
      setItems(r.data);
      if (r.data.length && window.location.hash === "#video-reviews") {
        setTimeout(() => document.getElementById("video-reviews")?.scrollIntoView({ behavior: "smooth", block: "start" }), 300);
      }
    }).catch(() => {});
  }, [tourSlug]);
  if (!items.length) return null;

  return (
    <section id="video-reviews" className="scroll-mt-24" data-testid="tour-video-reviews">
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-terracotta mb-2">Real travellers</p>
      <h2 className="font-display font-bold text-2xl tracking-tight mb-4">Video reviews from this trip</h2>
      <div className="flex gap-3 overflow-x-auto snap-x pb-2 -mx-1 px-1">
        {items.map((r) => (
          <div key={r.token} className="w-40 sm:w-48 shrink-0 snap-start"><VideoReviewCard review={{ ...r, trip_name: null }} /></div>
        ))}
      </div>
    </section>
  );
}
